import { useQuery } from '@tanstack/react-query'
import { WalletBalance } from 'pages/Wallets/types'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getWalletBalances } from 'services/WalletsService'

export const useGetWalletBalances = () => {
  return useQuery<WalletBalance[]>({
    queryKey: reactQueryKeys.walletBalances(),
    queryFn: getWalletBalances,
  })
}
